<template>
  <div>
    <div class="mapLoader" v-if="mapLoader">
    <v-progress-circular
      :size="50"
      :width="4"
      color="#2E674F"
      indeterminate
    ></v-progress-circular>
    </div>
    <div class="adoptionMapWidth">
        <div class="google-map" id="google-map" ref="google-map"></div>
    </div>
  </div>
</template>
<script>
import gmapsInit from '@/utils/googlemap'
import ENV_CONSTANTS from '../../../config/envVariables'
import CONSTANTS from '../../../config/constant'
export default {
  name: 'CodeAdoptionWorldMap',
  data: () => ({
    google: null,
    map: null,
    dataLayer: '',
    countryName: '',
    stateName: '',
    countyName: '',
    jurisdictionName: '',
    townshipName: '',
    mapDeatilsData: '',
    polygonApiUrl: ENV_CONSTANTS.POLYLIGON_API_URL,
    polygonEmailAddress: ENV_CONSTANTS.POLYLIGON_API_EMAIL_ADDRESS,
    mapLoader: true
  }),
  computed: {
    mapDeatils () {
      return this.mapDeatilsData
    }
  },
  async mounted () {
    try {
      // init and wait for the Google script is mounted
      this.google = await gmapsInit()
      // if the location is already set, for example
      // when returning back to this view from another one
      this.drawGMap()
    } catch (err) {
      this.defaultUsaMap()
      this.$globalStates.notification.type = 'error'
      this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(err)
      this.$globalStates.notification.init_notifications = true
    }
  },
  methods: {
    getMapDetails () {
      this.countryName = typeof this.$route.params.countryName !== 'undefined' ? this.$route.params.countryName.replace(/-/g, ' ') : this.$route.params.countryName
      let searchQuery = ''
      if (this.countryName !== '') {
        searchQuery = 'q=' + this.countryName
      }
      const url = `${this.polygonApiUrl}search?${searchQuery}&format=json&polygon_geojson=1&addressdetails=1&email=${this.polygonEmailAddress}`
      this.$axios.get(url, { withCredentials: false }).then(
        response => {
          this.mapDeatilsData = response.data
          if (response.data.length > 0) {
            this.createMap()
            this.initializeDataLayer()
          } else {
            this.defaultUsaMap()
          }
        },
        error => {
          this.defaultUsaMap()
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(error)
          this.$globalStates.notification.init_notifications = true
        }
      )
    },
    async drawGMap () {
      await this.getMapDetails()
    },
    initializeDataLayer () {
      if (this.dataLayer) {
        this.dataLayer.forEach(function (feature) {
          this.dataLayer.remove(feature)
        })
        this.dataLayer = null
      }
      this.dataLayer = new this.google.maps.Data({ map: this.map }) // initialize data layer which contains the boundaries. It's possible to have multiple data layers on one map
      this.dataLayer.setStyle({ // using set style we can set styles for all boundaries at once
        fillColor: 'blue',
        strokeColor: 'black',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillOpacity: 0.1
      })
      let setMapLayerData = {
        'type': 'FeatureCollection',
        'features': [{
          'type': 'Feature',
          'properties': {
            'stroke': '#555555',
            'stroke-width': 2,
            'stroke-opacity': 1
          },
          'geometry': {
            type: '',
            coordinates: []
          }
        }]
      }
      setMapLayerData.features[0].geometry.type = this.mapDeatilsData[0].geojson.type
      setMapLayerData.features[0].geometry.coordinates = this.mapDeatilsData[0].geojson.coordinates
      this.dataLayer.addGeoJson(setMapLayerData)
      this.mapLoader = false
    },
    createMap () {
      this.map = new this.google.maps.Map(document.getElementById('google-map'), {
        zoom: 8,
        region: CONSTANTS.DEFAULT_COUNTRY_ABBR,
        center: { lat: parseFloat(this.mapDeatilsData[0].lat), lng: parseFloat(this.mapDeatilsData[0].lon) },
        mapTypeControl: true,
        mapTypeControlOptions: { style: this.google.maps.MapTypeControlStyle.DROPDOWN_MENU },
        navigationControl: true,
        mapTypeId: this.google.maps.MapTypeId.ROADMAP
      })
      // Set map center dynamically
      let latMin = parseFloat(this.mapDeatilsData[0].boundingbox[0])
      let latMax = parseFloat(this.mapDeatilsData[0].boundingbox[1])
      let lngMin = parseFloat(this.mapDeatilsData[0].boundingbox[2])
      let lngMax = parseFloat(this.mapDeatilsData[0].boundingbox[3])

      if (this.countryName.toLowerCase() === 'antarctica') {
        latMin = 0
        lngMin = 0
        latMax = -75
        lngMax = 0
      }
      this.map.setCenter(new this.google.maps.LatLng(
        ((latMax + latMin) / 2.0),
        ((lngMax + lngMin) / 2.0)
      ))

      this.map.fitBounds(new this.google.maps.LatLngBounds(
        // bottom left
        new this.google.maps.LatLng(latMin, lngMin),
        // top right
        new this.google.maps.LatLng(latMax, lngMax)
      ))
    },
    defaultUsaMap () {
      this.map = new this.google.maps.Map(document.getElementById('google-map'), {
        zoom: 4,
        region: CONSTANTS.DEFAULT_COUNTRY_ABBR,
        center: { lat: CONSTANTS.DEFAULT_US_LAT, lng: CONSTANTS.DEFAULT_US_LNG },
        mapTypeControl: true,
        mapTypeControlOptions: { style: this.google.maps.MapTypeControlStyle.DROPDOWN_MENU },
        navigationControl: true,
        mapTypeId: this.google.maps.MapTypeId.ROADMAP
      })
      this.mapLoader = false
    }
  }
}
</script>
<style scoped>
.google-map {
  width: 100%;
  height: 400px;
}
.mapLoader {
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>
